import { useState } from "react";

function IPhone18ProInfo() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="detail-info">
      <h1 style={{textAlign: 'center', fontSize: '30px'}}>
        <strong>iPhone 18 Pro</strong>
      </h1>

      <div className={`content ${showMore ? "expanded" : "collapsed"}`}>
        <p>
          <strong>iPhone 18 Pro</strong> là mẫu iPhone cao cấp hướng đến người
          dùng muốn trải nghiệm đầy đủ công nghệ Pro trong thiết kế gọn hơn Pro
          Max. Thế hệ mới nổi bật với chip A20 Pro, hệ thống ba camera 48MP Pro
          Fusion, camera chính hỗ trợ khẩu độ thay đổi, Telephoto 8x chất lượng
          quang học, camera trước 18MP Center Stage và hệ thống tản nhiệt buồng
          hơi thế hệ mới.
        </p>

        <p>
          Bên cạnh nâng cấp về camera và hiệu năng, iPhone 18 Pro còn sở hữu màn
          hình Super Retina XDR 6,3 inch ProMotion 120Hz, bốn tùy chọn dung lượng
          từ 256GB đến 2TB và thời gian xem video lên đến 34 giờ. Đây là lựa
          chọn đáng chú ý với người muốn cấu hình Pro nhưng ưu tiên kích thước dễ
          sử dụng hơn so với iPhone 18 Pro Max.
        </p>

        {showMore && (
          <>
            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/tong-hop-cac-tinh-nang-cua-iphone-18-tu-choi-game-toi-dung-co-ban.webp"
                alt="tong-hop-cac-tinh-nang-cua-iphone-18-tu-choi-game-toi-dung-co-ban"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro tập trung nâng cấp vào camera, hiệu năng, AI và khả
              năng duy trì hiệu suất khi xử lý tác vụ nặng. Camera chính 48MP
              lần đầu hỗ trợ nhiều mức khẩu độ, A20 Pro kết hợp GPU 7 lõi và Bộ
              Đôi Neural Engine 16 lõi, trong khi hệ thống tản nhiệt buồng hơi
              được mở rộng để xử lý tốt hơn các workload kéo dài.
            </p>

            <p>Những điểm đáng chú ý trên iPhone 18 Pro gồm:</p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Hạng mục
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Super Retina XDR OLED 6,3 inch, ProMotion đến 120Hz
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    CPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6 lõi
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    GPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    7 lõi với Neural Accelerators
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    AI
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Bộ Đôi Neural Engine 16 lõi, Apple Intelligence và Siri AI
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera chính
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Main, hỗ trợ khẩu độ thay đổi
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera Ultra Wide
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Ultra Wide
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera Telephoto
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Telephoto, 4x và 8x chất lượng quang học
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera trước
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    18MP Center Stage
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Dung lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB, 512GB, 1TB, 2TB
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Thời gian xem video
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 34 giờ
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sạc nhanh
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 50% trong khoảng 15 phút với bộ tiếp hợp tương thích
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Kết nối
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    5G, Wi-Fi 7, Bluetooth 6, Thread, Apple N1, modem C2
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màu sắc
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đen, Bạc, Băng Thanh, Đỏ Burgundy
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Thiết kế iPhone 18 Pro gọn hơn nhưng vẫn đầy đủ trải nghiệm Pro
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-mau-bac-Silver.webp"
                alt="iPhone-18-Pro-mau-bac-Silver"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro có kích thước 150 x 71,9 x 8,75 mm và trọng lượng
              211g. So với phiên bản Pro Max, thiết bị nhỏ và nhẹ hơn, tạo lợi
              thế với người thường xuyên sử dụng điện thoại bằng một tay hoặc
              không muốn mang theo smartphone màn hình quá lớn.
            </p>

            <p>
              Apple sử dụng thiết kế nguyên khối nhôm, kết hợp Ceramic Shield 2
              ở mặt trước và Ceramic Shield ở mặt sau. Máy đạt chuẩn IP68 theo
              IEC 60529 trong điều kiện thử nghiệm của Apple.
            </p>

            <p>
              Điểm đáng chú ý ở iPhone 18 Pro là người dùng không phải đánh đổi
              những tính năng Pro quan trọng để có kích thước nhỏ hơn. Máy vẫn
              sử dụng A20 Pro, hệ thống ba camera 48MP Pro Fusion và các công cụ
              video chuyên nghiệp tương tự Pro Max.
            </p>

            <h3>
              <strong>iPhone 18 Pro có những màu nào?</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp"
                alt="iPhone-18-Pro-Burgundy"
                style={{ width: "100%" }}
              />
            </figure>

            <p>Apple cung cấp iPhone 18 Pro với bốn màu:</p>

            <ul>
              <li>
                <strong>Đen:</strong> hướng đến phong cách tối giản và trung
                tính.
              </li>
              <li>
                <strong>Bạc:</strong> lựa chọn sáng, dễ kết hợp với nhiều loại
                phụ kiện.
              </li>
              <li>
                <strong>Băng Thanh:</strong> mang sắc thái nhẹ và khác biệt hơn
                các màu truyền thống.
              </li>
              <li>
                <strong>Đỏ Burgundy:</strong> nổi bật hơn và phù hợp với người
                muốn thiết bị có dấu ấn cá nhân rõ ràng.
              </li>
            </ul>

            <p>
              Màu sắc không ảnh hưởng đến cấu hình hay tính năng, vì vậy lựa
              chọn chủ yếu phụ thuộc vào sở thích và phong cách sử dụng.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Màn hình 6,3 inch ProMotion 120Hz có phải lợi thế của iPhone 18
                Pro?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-co-dynamic-island-nho-hon-dang-ke.webp"
                alt="iphone-18-pro-co-dynamic-island-nho-hon-dang-ke"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro sở hữu màn hình Super Retina XDR OLED 6,3 inch với
              độ phân giải 2622 x 1206 pixel và mật độ điểm ảnh 460 ppi.
            </p>

            <p>
              Công nghệ ProMotion cho phép tốc độ làm mới thích ứng lên đến
              120Hz, giúp thao tác cuộn, chuyển cảnh và nội dung hỗ trợ tần số
              quét cao hiển thị mượt hơn. Màn hình còn tích hợp Always-On
              Display, HDR, True Tone, dải màu rộng P3 và Dynamic Island.
            </p>

            <p>
              Độ sáng ngoài trời tối đa đạt 3.000 nit, trong khi độ sáng HDR đạt
              tối đa 1.600 nit. Apple cũng trang bị lớp phủ chống phản chiếu
              nhằm cải thiện khả năng quan sát trong môi trường ánh sáng mạnh.
            </p>

            <p>
              So với Pro Max 6,9 inch, màn hình 6,3 inch tạo ra sự cân bằng
              khác: không gian hiển thị nhỏ hơn nhưng thân máy dễ cầm và mang
              theo hơn. Đây là một trong những lý do chính để chọn iPhone 18 Pro
              thay vì mặc định bước lên Pro Max.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Chip A20 Pro có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/Chip-a20-pro-voi-7-core-gpu.webp"
                alt="Chip-a20-pro-voi-7-core-gpu"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro sử dụng <strong>chip A20 Pro</strong> với CPU 6 lõi
              gồm 2 lõi hiệu năng cao và 4 lõi tiết kiệm điện. GPU có 7 lõi và
              được tích hợp Neural Accelerators, kết hợp với Bộ Đôi Neural
              Engine 16 lõi dành cho các tác vụ trí tuệ nhân tạo trên thiết bị.
            </p>

            <p>
              Apple cho biết A20 Pro sử dụng công nghệ đóng gói lấy cảm hứng từ
              dòng chip M. Cách bố trí chip được tối ưu nhằm cải thiện quá trình
              truyền nhiệt và hỗ trợ duy trì hiệu năng khi xử lý workload lớn.
            </p>

            <p>
              Theo công bố của Apple, hiệu năng đồ họa có thể nhanh hơn đến 40%
              so với iPhone 17 Pro trong những điều kiện phù hợp. Tuy nhiên,
              điểm đáng chú ý không chỉ nằm ở hiệu năng tức thời mà còn ở khả
              năng duy trì hiệu suất khi chơi game, chỉnh sửa video hoặc chạy mô
              hình AI trong thời gian dài.
            </p>

            <h3>
              <strong>Buồng hơi thế hệ mới hỗ trợ duy trì hiệu năng</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-buong-hoi-kich-thuoc-lon-hon-may-mat-hon.webp"
                alt="iphone-18-pro-buong-hoi-kich-thuoc-lon-hon-may-mat-hon"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Apple trang bị hệ thống tản nhiệt buồng hơi thế hệ mới với diện
              tích bề mặt lớn hơn. Hệ thống này kết hợp với các vật liệu dẫn
              nhiệt và thiết kế A20 Pro để đưa nhiệt ra khỏi khu vực xử lý nhanh
              hơn.
            </p>

            <p>
              Theo Apple, cấu trúc mới có thể giúp hiệu năng duy trì tốt hơn đến
              40% so với iPhone 17 Pro trong các workload phù hợp.
            </p>

            <p>
              Với người chơi game nặng hoặc thường xuyên chỉnh sửa video trực
              tiếp trên điện thoại, khả năng duy trì hiệu năng có ý nghĩa thực
              tế hơn việc chỉ tăng điểm benchmark trong thời gian ngắn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Apple Intelligence và Siri AI trên iPhone 18 Pro</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-chup-anh-va-dung-siri-ai.webp"
                alt="iphone-18-pro-chup-anh-va-dung-siri-ai"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              A20 Pro được thiết kế để xử lý nhiều tác vụ AI trực tiếp trên
              thiết bị. Neural Accelerators, Bộ Đôi Neural Engine 16 lõi và băng
              thông bộ nhớ cao hơn tạo nền tảng cho Apple Intelligence thế hệ
              mới.
            </p>

            <p>
              Siri AI là một phần trong hệ thống này, hướng đến khả năng giao
              tiếp tự nhiên hơn, hiểu ngữ cảnh tốt hơn và tích hợp sâu hơn với
              các ứng dụng.
            </p>

            <p>
              Tuy nhiên, người dùng cần phân biệt giữa khả năng phần cứng và
              thời điểm tính năng được triển khai. Apple hiện cho biết Siri AI
              mới sẽ ra mắt trước bằng tiếng Anh, vì vậy tính khả dụng tại Việt
              Nam còn phụ thuộc vào lịch phát hành phần mềm và ngôn ngữ hỗ trợ.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Camera iPhone 18 Pro có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/camera-iphone-18-pro.webp"
                alt="camera-iphone-18-pro"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Hệ thống camera là một trong những nâng cấp lớn nhất trên iPhone
              18 Pro. Apple sử dụng ba camera sau đều có độ phân giải 48MP, gồm
              Fusion Main, Fusion Ultra Wide và Fusion Telephoto.
            </p>

            <p>
              Điểm đáng chú ý nhất là camera chính hỗ trợ khẩu độ thay đổi,
              trong khi Telephoto cung cấp mức zoom 4x và 8x chất lượng quang
              học. Đây là những thay đổi mở rộng khả năng kiểm soát hình ảnh
              thay vì chỉ tăng độ phân giải cảm biến.
            </p>

            <h3>
              <strong>Camera chính 48MP lần đầu có khẩu độ thay đổi</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/camera-iphone-18-pro-anh-chup-khau-do-f28.webp"
                alt="camera-iphone-18-pro-anh-chup-khau-do-f28"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera 48MP Fusion Main sử dụng tiêu cự 24mm và hỗ trợ bốn mức
              khẩu độ gồm <strong>ƒ/1,48, ƒ/1,8, ƒ/2,8 và ƒ/4,0</strong>.
            </p>

            <p>
              Khẩu độ ảnh hưởng đến lượng ánh sáng đi vào cảm biến và độ sâu
              trường ảnh. Khẩu độ lớn có thể hỗ trợ thu nhận nhiều ánh sáng hơn,
              trong khi khẩu độ nhỏ hơn có thể mở rộng vùng ảnh rõ trong những
              trường hợp phù hợp.
            </p>

            <p>
              Nhờ khả năng thay đổi khẩu độ, camera iPhone 18 Pro linh hoạt hơn
              khi xử lý nhiều bối cảnh chụp khác nhau. Đây cũng là một tính năng
              đủ lớn để được phân tích riêng trong bài chuyên sâu về khẩu độ
              thay đổi trên iPhone 18 Pro.
            </p>

            <h3>
              <strong>Camera Ultra Wide 48MP hỗ trợ macro</strong>
            </h3>

            <p>
              Camera 48MP Fusion Ultra Wide có tiêu cự 13mm, khẩu độ ƒ/2,2 và
              trường nhìn 120 độ. Camera phù hợp với ảnh phong cảnh, kiến trúc,
              nhóm đông người hoặc các tình huống cần trường nhìn rộng.
            </p>

            <p>
              Hệ thống còn hỗ trợ chụp macro 48MP, giúp người dùng ghi lại các
              chủ thể ở khoảng cách gần với nhiều chi tiết hơn.
            </p>

            <h3>
              <strong>Telephoto 48MP hỗ trợ zoom 4x và 8x</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-co-camera-chinh-48mp-co-kha-nang-dieu-chinh-tieu-cu.webp"
                alt="iphone-18-pro-co-camera-chinh-48mp-co-kha-nang-dieu-chinh-tieu-cu"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera 48MP Fusion Telephoto sử dụng thiết kế tetraprism, hỗ trợ
              mức 4x tương đương tiêu cự 100mm.
            </p>

            <p>
              Hệ thống đồng thời cung cấp mức{" "}
              <strong>8x chất lượng quang học</strong> tương đương tiêu cự
              200mm. Điều này mở rộng khả năng chụp chân dung, sân khấu, kiến
              trúc, sự kiện và những chủ thể ở xa.
            </p>

            <p>
              iPhone 18 Pro hỗ trợ phạm vi thu phóng quang học 16x và zoom kỹ
              thuật số lên đến 40x. Tuy nhiên, chất lượng hình ảnh ở các mức zoom
              kỹ thuật số cao sẽ khác với những tiêu cự chất lượng quang học.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Camera trước 18MP Center Stage có gì đáng chú ý?
              </strong>
            </h2>

            <p>
              Camera trước của iPhone 18 Pro được nâng lên{" "}
              <strong>18MP Center Stage</strong> với khẩu độ ƒ/1,9 và khả năng tự
              động lấy nét theo pha.
            </p>

            <p>
              Center Stage không chỉ phục vụ cuộc gọi video mà còn được ứng dụng
              cho ảnh và video. Camera có thể hỗ trợ điều chỉnh khung hình theo
              chủ thể trong những tình huống phù hợp.
            </p>

            <p>
              Ghi Hình Kép cho phép khai thác đồng thời camera trước và sau, tạo
              thêm lựa chọn cho vlog, phỏng vấn, review hoặc các dạng nội dung
              cần ghi lại cả người quay lẫn bối cảnh phía trước.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro quay video có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-quay-video-co-kha-nang-focus-vao-1-nguoi-cu-the.webp"
                alt="iphone-18-pro-quay-video-co-kha-nang-focus-vao-1-nguoi-cu-the"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro tiếp tục hướng đến nhóm creator và người dùng chuyên
              nghiệp với nhiều công cụ video nâng cao.
            </p>

            <p>
              Camera Fusion Main hỗ trợ quay 4K Dolby Vision lên đến 120 fps.
              Ngoài ra, máy còn có:
            </p>

            <ul>
              <li>
                ProRes lên đến 4K 120 fps khi ghi vào ổ đĩa ngoài tương thích.
              </li>
              <li>ProRes RAW.</li>
              <li>Apple Log 2.</li>
              <li>ACES.</li>
              <li>Genlock.</li>
              <li>Chế độ Điện Ảnh lên đến 4K Dolby Vision 60 fps.</li>
              <li>Ghi Hình Kép lên đến 4K Dolby Vision 30 fps.</li>
              <li>Bốn micrô chuẩn phòng thu.</li>
            </ul>

            <p>
              Với người dùng phổ thông, Dolby Vision và khả năng chống rung sẽ
              là những yếu tố dễ khai thác hơn. Trong khi đó, ProRes RAW, Apple
              Log 2 và Genlock hướng nhiều hơn đến workflow quay dựng và hậu kỳ
              chuyên nghiệp.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Pin iPhone 18 Pro dùng được bao lâu?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/pin-iphone-18-pro-thoi-luong-dung-video.webp"
                alt="pin-iphone-18-pro-thoi-luong-dung-video"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Theo công bố của Apple, iPhone 18 Pro có thời gian sử dụng thông
              thường lên đến 23 giờ, xem video lên đến <strong>34 giờ</strong>{" "}
              và xem video trực tuyến lên đến 31 giờ.
            </p>

            <p>
              Thời lượng thực tế còn phụ thuộc vào độ sáng màn hình, mạng di
              động, ứng dụng, camera, game và thói quen sử dụng. Vì vậy, các con
              số trên nên được hiểu là mốc thử nghiệm của Apple thay vì thời
              gian sử dụng cố định cho mọi người.
            </p>

            <h3>
              <strong>Sạc 50% trong khoảng 15 phút</strong>
            </h3>

            <p>
              iPhone 18 Pro hỗ trợ sạc nhanh lên đến 50% trong khoảng 15 phút
              khi sử dụng bộ tiếp hợp từ 60W trở lên có cơ chế Cung Cấp Điện Áp
              Linh Hoạt và cáp USB-C tương thích.
            </p>

            <p>
              MagSafe và Qi2 đều hỗ trợ công suất sạc không dây lên đến 25W. Với
              MagSafe và bộ tiếp hợp phù hợp, Apple công bố thiết bị có thể đạt
              khoảng 50% pin trong 30 phút.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro có những dung lượng nào?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/tong-hop-thong-so-ky-thuat-ben-trong-iphone-18-pro.webp"
                alt="tong-hop-thong-so-ky-thuat-ben-trong-iphone-18-pro"
                style={{ width: "100%" }}
              />
            </figure>

            <p>iPhone 18 Pro có bốn tùy chọn dung lượng:</p>

            <ul>
              <li>
                <strong>256GB:</strong> phù hợp với phần lớn nhu cầu hàng ngày,
                đặc biệt khi thường xuyên sử dụng iCloud.
              </li>
              <li>
                <strong>512GB:</strong> cân bằng tốt cho người chụp quay nhiều,
                chơi nhiều game hoặc sử dụng máy lâu dài.
              </li>
              <li>
                <strong>1TB:</strong> hướng đến creator, người quay video thường
                xuyên hoặc cần giữ nhiều dữ liệu trực tiếp trên máy.
              </li>
              <li>
                <strong>2TB:</strong> dành cho nhu cầu lưu trữ rất lớn, đặc biệt
                khi video chuyên nghiệp là một phần quan trọng trong workflow.
              </li>
            </ul>

            <p>
              Việc tăng dung lượng không làm thay đổi chip, camera hay màn hình.
              Người dùng nên lựa chọn dựa trên lượng dữ liệu thực tế thay vì mặc
              định chọn phiên bản cao nhất.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Dung lượng
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Phù hợp với nhu cầu
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sử dụng hàng ngày, ảnh/video thông thường, có dùng cloud
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    512GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Quay chụp nhiều, game lớn, sử dụng dài hạn
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    1TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Creator, nhiều video 4K, workflow chuyên sâu
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    2TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lưu lượng dữ liệu rất lớn, nhiều project video chuyên nghiệp
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>
              <strong style={{fontSize: '22px'}}>Kết nối Wi-Fi 7, Bluetooth 6 và modem Apple C2</strong>
            </h2>

            <p>
              iPhone 18 Pro sử dụng chip mạng không dây Apple N1, hỗ trợ Wi-Fi
              7, Bluetooth 6 và Thread.
            </p>

            <p>
              Apple cũng trang bị modem C2 cùng Ultra Wideband thế hệ thứ hai,
              5G, NFC và GPS tần số kép. Cổng USB-C hỗ trợ DisplayPort và USB 3
              với tốc độ truyền dữ liệu lên đến 10Gb/s.
            </p>

            <p>
              Tại thị trường Việt Nam, Apple công bố thiết bị hỗ trợ SIM kép gồm
              nano SIM và eSIM, đồng thời hỗ trợ eSIM kép.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                iPhone 18 Pro và iPhone 18 Pro Max khác nhau gì?
              </strong>
            </h2>

            <p>
              iPhone 18 Pro và Pro Max chia sẻ phần lớn cấu hình cốt lõi. Cả hai
              đều sử dụng A20 Pro, GPU 7 lõi, hệ thống ba camera 48MP Pro Fusion,
              camera trước 18MP Center Stage và cùng các mức dung lượng lưu trữ.
            </p>

            <p>
              Khác biệt lớn nhất nằm ở màn hình, kích thước, trọng lượng và pin.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Tiêu chí
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro Max
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6,3 inch
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6,9 inch
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Trọng lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    211g
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    249g
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera sau
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Pro Fusion
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Pro Fusion
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Xem video tối đa
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    34 giờ
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    43 giờ
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Phù hợp
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Ưu tiên gọn hơn
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Ưu tiên màn hình lớn và pin dài
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Vì camera và chip không phải khác biệt chính, người dùng không
              nhất thiết phải chọn Pro Max để có hiệu năng hoặc hệ thống camera
              tốt hơn. iPhone 18 Pro phù hợp hơn nếu ưu tiên sự cân bằng giữa
              cấu hình Pro và kích thước dễ sử dụng.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro phù hợp với ai?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iphone-18-pro-va-he-sinh-thai-san-pham-apple.webp"
                alt="iphone-18-pro-va-he-sinh-thai-san-pham-apple"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro phù hợp với những người muốn trải nghiệm các tính
              năng cao cấp nhưng không cần một thiết bị quá lớn.
            </p>

            <ul>
              <li>
                <strong>Người thích smartphone gọn hơn:</strong> màn hình 6,3
                inch dễ cầm hơn Pro Max 6,9 inch.
              </li>
              <li>
                <strong>Người chụp ảnh nhiều:</strong> hệ thống ba camera 48MP,
                khẩu độ thay đổi và Telephoto 8x tạo ra nhiều lựa chọn tiêu cự.
              </li>
              <li>
                <strong>Creator:</strong> ProRes RAW, Apple Log 2, video 4K
                Dolby Vision và USB 3 hỗ trợ workflow quay dựng.
              </li>
              <li>
                <strong>Người chơi game:</strong> A20 Pro, GPU 7 lõi và hệ thống
                tản nhiệt buồng hơi hướng đến khả năng xử lý tác vụ nặng kéo dài.
              </li>
              <li>
                <strong>Người quan tâm AI:</strong> A20 Pro được thiết kế cho
                Apple Intelligence và các mô hình AI trên thiết bị.
              </li>
              <li>
                <strong>Người nâng cấp từ iPhone đời cũ:</strong> có thể nhận
                được đồng thời nâng cấp về camera, hiệu năng, màn hình và thời
                lượng sử dụng.
              </li>
            </ul>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Ai nên cân nhắc iPhone 18 Pro Max thay vì iPhone 18 Pro?
              </strong>
            </h2>

            <p>
              iPhone 18 Pro không phải lựa chọn tối ưu nếu màn hình và pin là hai
              ưu tiên lớn nhất.
            </p>

            <p>
              Người thường xuyên xem phim, chơi game trên màn hình lớn, chỉnh
              sửa nội dung trực tiếp trên điện thoại hoặc cần thời lượng pin dài
              hơn có thể phù hợp với iPhone 18 Pro Max.
            </p>

            <p>
              Ngược lại, nếu không muốn đánh đổi sự gọn nhẹ chỉ để có thêm màn
              hình và pin, iPhone 18 Pro mang lại gần như toàn bộ hệ thống công
              nghệ Pro trong thân máy nhỏ hơn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Có nên đặt cọc iPhone 18 Pro?</strong>
            </h2>

            <p>
              iPhone 18 Pro đáng cân nhắc với người muốn một chiếc iPhone cao cấp
              nhưng không thích kích thước lớn của Pro Max. Máy giữ gần như toàn
              bộ những thành phần quan trọng nhất của dòng Pro, từ A20 Pro,
              camera 48MP Pro Fusion, khẩu độ thay đổi đến Telephoto 8x và các
              công cụ video chuyên nghiệp.
            </p>

            <p>
              Giá trị lớn nhất của iPhone 18 Pro nằm ở sự cân bằng. Người dùng
              vẫn có màn hình 120Hz, hiệu năng cao, camera chuyên sâu và nhiều
              tùy chọn dung lượng, nhưng trong thân máy 6,3 inch gọn hơn.
            </p>

            <p>
              Ở giai đoạn đặt cọc, người dùng nên ưu tiên xác định ba yếu tố
              trước khi lựa chọn: dung lượng cần sử dụng, màu sắc yêu thích và
              việc màn hình 6,3 inch có phù hợp hơn Pro Max 6,9 inch hay không.
              Chính sách giá, ưu đãi và thời gian nhận hàng nên được kiểm tra
              trực tiếp tại ShopDunk theo từng thời điểm.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Câu hỏi thường gặp về iPhone 18 Pro</strong>
            </h2>

            <h3>
              <strong>iPhone 18 Pro màn hình bao nhiêu inch?</strong>
            </h3>
            <p>
              iPhone 18 Pro sử dụng màn hình Super Retina XDR OLED 6,3 inch với
              công nghệ ProMotion và tốc độ làm mới thích ứng lên đến 120Hz.
            </p>

            <h3>
              <strong>iPhone 18 Pro dùng chip gì?</strong>
            </h3>
            <p>
              Máy sử dụng chip A20 Pro với CPU 6 lõi, GPU 7 lõi tích hợp Neural
              Accelerators và Bộ Đôi Neural Engine 16 lõi.
            </p>

            <h3>
              <strong>iPhone 18 Pro có zoom 8x không?</strong>
            </h3>
            <p>
              Có. Camera Fusion Telephoto hỗ trợ mức 4x ở tiêu cự tương đương
              100mm và mức 8x chất lượng quang học tương đương 200mm.
            </p>

            <h3>
              <strong>Camera iPhone 18 Pro có gì mới?</strong>
            </h3>
            <p>
              Điểm nổi bật nhất là camera chính 48MP hỗ trợ bốn mức khẩu độ
              ƒ/1,48, ƒ/1,8, ƒ/2,8 và ƒ/4,0. Máy còn có Ultra Wide 48MP,
              Telephoto 48MP và camera trước 18MP Center Stage.
            </p>

            <h3>
              <strong>iPhone 18 Pro có những dung lượng nào?</strong>
            </h3>
            <p>
              Apple cung cấp bốn mức dung lượng gồm 256GB, 512GB, 1TB và 2TB.
            </p>

            <h3>
              <strong>Pin iPhone 18 Pro dùng được bao lâu?</strong>
            </h3>
            <p>
              Theo Apple, thiết bị có thời gian xem video tối đa 34 giờ và xem
              video trực tuyến tối đa 31 giờ. Thời lượng thực tế sẽ thay đổi
              theo cách sử dụng.
            </p>

            <h3>
              <strong>iPhone 18 Pro có SIM vật lý không?</strong>
            </h3>
            <p>
              Theo thông số Apple Việt Nam, máy hỗ trợ SIM kép gồm nano SIM và
              eSIM, đồng thời hỗ trợ eSIM kép.
            </p>

            <h3>
              <strong>iPhone 18 Pro hay Pro Max đáng chọn hơn?</strong>
            </h3>
            <p>
              iPhone 18 Pro phù hợp với người ưu tiên thân máy gọn hơn. Pro Max
              phù hợp hơn nếu màn hình 6,9 inch và thời lượng pin dài là ưu tiên
              chính. Hai phiên bản sử dụng cùng chip A20 Pro và hệ thống camera
              Pro Fusion cốt lõi.
            </p>
          </>
        )}
      </div>

      <div className="all-toggle-btn">
        <button
          className="toggle-btn"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Thu gọn" : "Xem thêm"}
        </button>
      </div>

      <style>{`
        .content.collapsed {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .toggle-btn {
          margin-top: 10px;
          padding: 8px 16px;
          border: none;
          border-radius: 80px;
          cursor: pointer;
          background: #037CF6;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

export default IPhone18ProInfo;